import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { Button, Grid, makeStyles } from '@material-ui/core'
import AddIcon from '@mui/icons-material/Add'
import ListIcon from '@mui/icons-material/List'
import CalendarTodayIcon from '@mui/icons-material/CalendarToday'
import Typography from '../../../components/common/Typography'
import { IconEventManagement } from '../../../components/svg/Icons/Menu/IconEventManagement'
import { useTrans } from '../../../services/i18n'
import { selectUserPermissions, isEnabled } from '../../../selectors'

const useStyles = makeStyles({
  root: { padding: '20px 40px 12px' },
  listToggle: { marginRight: 8 },
  calendarToggle: { marginRight: 20 },
})

const MODULE_KEY = 'event-management'

const Header = ({ onAdd, view, onChangeView }) => {
  const { trans } = useTrans()
  const styles = useStyles()
  const permissions = useSelector(selectUserPermissions)
  const canCreate = isEnabled(permissions, MODULE_KEY, '', 'create')

  return (
    <Grid container className={styles.root} alignItems="center" justifyContent="space-between">
      <Grid item>
        <Typography variant="h4" weight="bold">
          <IconEventManagement /> {trans('events')}
        </Typography>
      </Grid>
      <Grid item>
        <Button
          className={styles.listToggle}
          variant={view === 'list' ? 'contained' : 'outlined'}
          color={view === 'list' ? 'primary' : 'default'}
          startIcon={<ListIcon />}
          onClick={() => onChangeView('list')}
        >
          {trans('list')}
        </Button>
        <Button
          className={styles.calendarToggle}
          variant={view === 'calendar' ? 'contained' : 'outlined'}
          color={view === 'calendar' ? 'primary' : 'default'}
          startIcon={<CalendarTodayIcon />}
          onClick={() => onChangeView('calendar')}
        >
          {trans('calendar')}
        </Button>
        {canCreate && (
          <Button variant="contained" color="primary" onClick={onAdd} startIcon={<AddIcon />}>
            {trans('add-event')}
          </Button>
        )}
      </Grid>
    </Grid>
  )
}

Header.propTypes = {
  onAdd: PropTypes.func.isRequired,
  view: PropTypes.oneOf(['list', 'calendar']).isRequired,
  onChangeView: PropTypes.func.isRequired,
}

export default Header
